import { render, staticRenderFns } from "./TermsAndConditions.vue?vue&type=template&id=899b8b82&scoped=true"
import script from "./TermsAndConditions.vue?vue&type=script&lang=js"
export * from "./TermsAndConditions.vue?vue&type=script&lang=js"
import style0 from "./TermsAndConditions.vue?vue&type=style&index=0&id=899b8b82&prod&scoped=true&lang=css"
import style1 from "./TermsAndConditions.vue?vue&type=style&index=1&id=899b8b82&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "899b8b82",
  null
  
)

export default component.exports